module.exports = __webpack_public_path__ + "img/logo.bb11f465.png";